import { ng, template, idiom as lang, http, skin } from 'entcore';

export let loginController = ng.controller('LoginController', ['$scope', ($scope) => {
	$scope.template = template;
	$scope.template.open('main', 'login-form');
	$scope.user = {};
	$scope.lang = lang;


	$scope.welcome = {	};
    var _callback = $scope.callBack;
    //init callback only if not already setted
    Object.defineProperty($scope, "callBack", {
        get : function(){
            return _callback;
        },set : function(value){
            if(!_callback){
                _callback = value;
            }
        }
    })

	http().get('/auth/configure/welcome').done(function (d) {
		$scope.welcome.content = d.welcomeMessage;
		if (!d.enabled) {
			$scope.welcome.hideContent = true;
		}
		if (!$scope.$$phase) {
			$scope.$apply();
		}
	})
		.e404(function () {
			$scope.welcome.hideContent = true;
			if (!$scope.$$phase) {
				$scope.$apply();
			}
		});

	$scope.cookieEnabled = navigator.cookieEnabled;
	const safeSplit = (str: string = "", pattern: string = "") => {
		if (typeof str == "string") {
			return str.split(pattern);
		} else {
			return [];
		}
	}
	const checkBrowser = (browser: { browser: string, version: number }) => {
		if (typeof browser == "undefined") {
			console.warn("[Auth][Login.checkBrowser] chould not identify browser NAME: ", browser, navigator.userAgent)
		} else if (typeof browser.version == "undefined") {
			console.warn("[Auth][Login.checkBrowser] chould not identify browser VERSION: ", browser, navigator.userAgent)
		}
	}
	const browser = function (userAgent) {
		if (userAgent.indexOf('Chrome') !== -1) {
			const chromeVersion = safeSplit(userAgent, 'Chrome/')[1];
			const version = parseInt(safeSplit(chromeVersion, '.')[0]);
			return {
				browser: 'Chrome',
				version: version,
				outdated: version < 39
			}
		}
		else if (userAgent.indexOf('IEMobile') !== -1) {
			const ieVersion = safeSplit(userAgent, 'IEMobile/')[1];
			const version = parseInt(safeSplit(ieVersion, ';')[0]);
			return {
				browser: 'MSIE',
				version: version,
				outdated: version < 10
			}
		}
		else if (userAgent.indexOf('AppleWebKit') !== -1 && userAgent.indexOf('Chrome') === -1) {
			const safariVersion = safeSplit(userAgent, 'Version/')[1];
			const version = parseInt(safeSplit(safariVersion, '.')[0]);
			return {
				browser: 'Safari',
				version: version,
				outdated: version < 7
			}
		}
		else if (userAgent.indexOf('Firefox') !== -1) {
			const ffVersion = safeSplit(userAgent, 'Firefox/')[1];
			const version = parseInt(safeSplit(ffVersion, '.')[0]);
			return {
				browser: 'Firefox',
				version: version,
				outdated: version < 34
			}
		}
		else if (userAgent.indexOf('MSIE') !== -1) {
			const msVersion = safeSplit(userAgent, 'MSIE ')[1];
			const version = parseInt(safeSplit(msVersion, ';')[0]);
			return {
				browser: 'MSIE',
				version: version,
				outdated: version < 10
			}
		}
		else if (userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('Trident') !== -1) {
			const msVersion = safeSplit(userAgent, 'rv:')[1];
			const version = parseInt(safeSplit(msVersion, '.')[0]);
			return {
				browser: 'MSIE',
				version: version,
				outdated: version < 10
			}
		}
	};

	$scope.browser = browser(navigator.userAgent);
	checkBrowser($scope.browser);
	if (window.location.href.indexOf('?') !== -1) {
		if (window.location.href.split('login=').length > 1) {
			$scope.login = window.location.href.split('login=')[1].split('&')[0];
		}
		if (window.location.href.split('activationCode=').length > 1) {
			$scope.activationCode = window.location.href.split('activationCode=')[1].split('&')[0];
		}
		if (window.location.search.split('callback=').length > 1) {
		    const raw = window.location.search.split('callback=')[1].split('&')[0];
		    const hashIdx = raw.indexOf('#');
		    _callback = hashIdx === -1 ? raw : raw.substring(0, hashIdx);
		    $scope.details = hashIdx === -1 ? "" : raw.substring(hashIdx + 1);
		} else if (window.location.search.split('callBack=').length > 1) {
		    const raw = window.location.search.split('callBack=')[1].split('&')[0];
		    const hashIdx = raw.indexOf('#');
		    _callback = hashIdx === -1 ? raw : raw.substring(0, hashIdx);
		    $scope.details = hashIdx === -1 ? "" : raw.substring(hashIdx + 1);
		}
	}

	http().get('/auth/context').done(function (data) {
		//$scope.callBack = data.callBack;
		$scope.cgu = data.cgu;
		if (!$scope.$$phase) {
			$scope.$apply();
		}
	});

	let conf: { overriding: Array<{ child: string; [key: string]: any }> } = { overriding: [] };
	const xhr = new XMLHttpRequest();
	xhr.open('get', '/assets/theme-conf.js');
	xhr.onload = async () => {
		eval(xhr.responseText.split('exports.')[1]);
		const currentTheme = conf.overriding.find(t => t.child === skin.skin);
		$scope.childTheme = currentTheme ? currentTheme.child : skin.skin;
		// 1er degré detection : primary skins extend the "panda" parent theme (e.g. openent1d).
		$scope.is1D = !!currentTheme && ((currentTheme as any).parent === 'panda' || currentTheme.child === 'openent1d');
		if (!$scope.$$phase) {
			$scope.$apply();
		}
	};
	xhr.send();

	$scope.connecting = false;

	$scope.onLoginSubmit = function (event) {
		// The form does a native POST to /auth/login: the server renders the
		// activation/reset pages and issues the success redirect itself. We only
		// guard here against multiple submissions (double-click, rapid Enter).
		if ($scope.connecting) {
			if (event) {
				event.preventDefault();
			}
			return;
		}
		$scope.connecting = true;
	};

	for (var i = 0; i < 10; i++) {
		if (history.pushState) {
			history.pushState('', '');
		}
	}

	$scope.noSpace = function (event) {
		if (event.keyCode === 32) {
			event.preventDefault();
		}
	}

	$scope.noUpperCase = function () {
		$scope.user.email = $scope.user.email.toLowerCase();
	}

}]);



// WEBPACK FOOTER //
// ./auth/src/main/resources/public/ts/controllers/login.ts